import styled from 'styled-components'

export const RadioWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`

export const styles = {
  main: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white'
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '1em',
    width: 'auto'
  },
  button: {
    marginTop: '2em',
    textAlign: 'center'
  },
  link: {
    textDecoration: 'none'
  },
  input: {
    display: 'none'
  },
  avatar: {
    width: '6em',
    height: '6em'
  },
  avatarWrapper: {
    display: 'flex',
    margin: '1em',
    justifyContent: 'center'
  }
}



// WEBPACK FOOTER //
// ./src/pages/SignupBin/styles.js